import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Creditors from './components/Creditors/Creditors';
import MainDetails from './components/MainDetails/MainDetails';
import MoneyInfo from './components/MoneyInfo/MoneyInfo';
import ScheduleInfo from './components/ScheduleInfo/ScheduleInfo';

import { getClaimDetails } from '@actions/claimDetails';

import {
  creditors,
  mainDetailsData,
  moneyInfoData,
  scheduleInfoData,
} from '@selectors/claimDetails';

import { isGreaterThanMobile } from '@selectors/browser';

import './ClaimDetails.scss';

class ClaimDetails extends React.Component {
  componentDidMount() {
    const {
      fetchClaimDetails,
      match: {
        params: {
          caseId,
          claimId,
        },
      },
      history: { replace },
    } = this.props;

    if (!Number(caseId)) {
      replace('/cases');
    } else if (!Number(claimId)) {
      replace(`/cases/${caseId}/claims`);
    } else {
      fetchClaimDetails(caseId, claimId);
    }
  }

  render() {
    const {
      creditors,
      mainDetailsData,
      match: { params: {
        caseId,
        claimId,
      } },
      moneyInfoData,
      scheduleInfoData,
    } = this.props;
    const { representsSchedule } = mainDetailsData;

    return (
      <div className="claim-details">
        {!representsSchedule && (
          <React.Fragment>
            <div className="claim-details__card">
              <MainDetails
                caseId={caseId}
                claimId={claimId}
                data={mainDetailsData}
              />
            </div>
            <div className="claim-details__card">
              <Creditors creditors={creditors} />
            </div>
            <div className="claim-details__card">
              <MoneyInfo data={moneyInfoData} />
            </div>
            {scheduleInfoData && (
              <div className="claim-details__card">
                <ScheduleInfo data={scheduleInfoData} />
              </div>
            )}
          </React.Fragment>
        )}
        {representsSchedule && (
          <div className="claim-details__card">
            <ScheduleInfo data={moneyInfoData} />
          </div>
        )}
      </div>
    );
  }
}

ClaimDetails.defaultProps = {
  scheduleInfoData: {},
};

ClaimDetails.propTypes = {
  creditors: PropTypes.array.isRequired,
  fetchClaimDetails: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  mainDetailsData: PropTypes.object.isRequired,
  moneyInfoData: PropTypes.object.isRequired,
  scheduleInfoData: PropTypes.object,
  match: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  creditors: creditors(state),
  isMobile: !isGreaterThanMobile(state),
  mainDetailsData: mainDetailsData(state),
  moneyInfoData: moneyInfoData(state),
  scheduleInfoData: scheduleInfoData(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchClaimDetails: getClaimDetails,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ClaimDetails);



// WEBPACK FOOTER //
// ./src/routes/Case/Claims/ClaimDetails/ClaimDetails.js